import React, { useEffect, useState } from 'react';
import { Button, Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { useNavigate, useLocation, NavLink } from 'react-router-dom';
import Loader from '../../components/loader/Loader';
import { getUser, hasPermission } from '../../helpers/jwt';
import GoBackButton from '../../components/GoBackButton';
import Tooltip from '../../components/tooltip/Tooltip';
import { FaArrowLeft } from 'react-icons/fa6';
import DivBetween from '../../components/div/DivBetween';
import LightButton from '../../components/button/LightButton';
import navigationConfig from '../menu/MenuConfig';

const logo = '/assets/img/logo.png';

const NavigationBar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [user, setUser] = useState(getUser());
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (location.state?.from === '/login') {
      setUser(getUser());
    }
  }, [location.state]);

  const handleLogout = () => {
    setLoader(true);
    localStorage.removeItem('user_jwt');
    localStorage.removeItem('user');
    localStorage.removeItem('perms');
    navigate('/login');
  };

  const navigationBarTitleValue = (
    <span className="d-inline-flex align-items-center">
      <span className="me-2 small text-muted">{user}</span>
      <i className="far fa-user-circle fs-5 text-secondary" />
    </span>
  );

  return (
    <>
      <Loader loader={loader} setLoader={setLoader} />
      <Navbar
        bg="white"
        variant="light"
        fixed="top"
        expand="lg"
        className="border-bottom px-3"
        style={{ height: '80px' }}
      >
        <Container fluid className="px-0">
          {/* Brand and toggle */}
          <Navbar.Brand
            className="navbar-brand-responsive d-flex justify-content-center align-items-center gap-2"
          >
            <img
              src={logo}
              alt="logo"
              className="navbar-logo"
            />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="main-navbar" />

          <Navbar.Collapse id="main-navbar" className="bg-white">
            {/* Sidebar menu items on mobile only */}
            <div className="d-md-none border-top pt-3 mt-3">
              <Nav className="flex-column">
                {navigationConfig
                  .filter((item) => !item.permission || hasPermission(item.permission))
                  .map(({ title, navigate, icon: Icon }) => (
                    <Nav.Link
                      as={NavLink}
                      key={title}
                      to={navigate}
                      className="d-flex align-items-center py-2"
                    >
                      <Icon className="me-2" />
                      {title}
                    </Nav.Link>
                  ))}
              </Nav>
            </div>

            <Nav className="me-auto align-items-center mt-3 mt-lg-0">
              <Tooltip tooltip={'Wróć'}>
                <GoBackButton
                  variant={'outline-secondary'}
                  className={'btn-circle me-2'}
                  label={<FaArrowLeft />}
                />
              </Tooltip>

              <Button
                variant="outline-secondary"
                className="rounded-pill px-4 fw-medium mt-2 mt-lg-0"
                onClick={() => navigate('/house-offer')}
              >
                Wyszukaj domek
              </Button>
            </Nav>

            <Nav className="ms-auto align-items-center mt-4 mt-lg-0">
              <DivBetween className="gap-2 flex-wrap">
                <LightButton
                  size="sm"
                  onClick={() =>
                    navigate('/legal-document/actual/regulamin')
                  }
                >
                  Regulamin
                </LightButton>
                <LightButton
                  size="sm"
                  onClick={() =>
                    navigate('/legal-document/actual/polityka-prywatnosci')
                  }
                >
                  Polityka prywatności
                </LightButton>
                <LightButton
                  size="sm"
                  onClick={() =>
                    navigate('/legal-document/actual/zasady-anulowania-rezerwacji')
                  }
                >
                  Zasady anulowania
                </LightButton>
              </DivBetween>

              <div className="vr mx-3 d-none d-lg-block" />

              <NavDropdown title={navigationBarTitleValue} className={"my-4 my-lg-0"} align="end">
                <NavDropdown.Item onClick={handleLogout}>
                  <i className="fas fa-sign-out-alt me-2 text-secondary" />
                  Wyloguj
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

    </>
  );
};

export default NavigationBar;
